import { useQuery } from '@tanstack/react-query';

import { getAssuEmployees, type GetAssuEmployeesResponse } from 'wg-api-sdk';

import wgApi from '@/lib/api/wgApi';
import type { QueryOptions } from '@/types/react-query';

import queryKeys from '../queryKeys';

export default function useAssuEmployees(
  options?: QueryOptions<GetAssuEmployeesResponse['items']>,
) {
  return useQuery({
    queryKey: queryKeys.employees.list('assu', undefined),
    queryFn: async () => {
      const result = await getAssuEmployees({}, wgApi);

      return result.items;
    },
    ...options,
  });
}
